import React from 'react';
import styles from './Page.module.css';
import usePageTitile from '@/shared/hooks/usePageTitile';

type PageProps = React.PropsWithChildren<{
  title?: string
}>;

export const Page: React.FC<PageProps> = ({ children, title }) => {
  usePageTitile(title)
  return(<div className={styles.page}>{children}</div>)
}


  